import type { BaseComponentProps } from "@neru/types";
import { deduplicateClass } from "@neru/utils";

export interface CardProps extends BaseComponentProps {
  children: React.ReactNode;
  onClick?: () => void;
}

export const Card = ({
  children,
  className,
  "data-testid": testId,
  onClick,
}: CardProps) => {
  return (
    <div
      className={deduplicateClass(
        `relative rounded-md bg-primary-0 px-6 py-8 drop-shadow-base

        ${onClick ? "cursor-pointer hover:drop-shadow-hover" : ""}
      `,
        className,
      )}
      data-testid={testId}
      onClick={onClick}
      onKeyDown={(e) => {
        if (onClick && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      {children}
    </div>
  );
};
